/* eslint-disable import/prefer-default-export */
import axios from 'axios';

export const postToChat = body =>
  axios
    .post('https://dorris-261912.appspot.com/api/chat', body)
    .then(({ data }) => data);
